import { render, staticRenderFns } from "./ResourceDetail.vue?vue&type=template&id=fede1d7a&scoped=true&"
import script from "./ResourceDetail.vue?vue&type=script&lang=js&"
export * from "./ResourceDetail.vue?vue&type=script&lang=js&"
import style0 from "./ResourceDetail.vue?vue&type=style&index=0&id=fede1d7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fede1d7a",
  null
  
)

export default component.exports